export enum FeaturedEnum {
  No,
  Yes,
}
